import * as io from 'io-ts';
import { Order } from './Application';
import { Address, Name } from './Buyer';

const ContactOptional = io.type({
  shippingAddress: io.union([Address, io.undefined]),
  billingAddress: io.union([Address, io.undefined]),
  name: io.union([Name, io.undefined]),
});

const ContactRequired = io.type({
  email: io.string,
  phone: io.string,
});

const Contact = io.intersection([
  ContactRequired,
  io.partial(ContactOptional.props),
]);

const Disclosure = io.type({
  name: io.string,
  acceptedAt: io.string,
});

const Disclosures = io.union([io.array(Disclosure), io.null]);

export const Cart = io.type({
  id: io.string,
  checkoutCompleteURL: io.string,
  checkoutErrorURL: io.string,
  createdAt: io.string,
  updatedAt: io.string,
  expiresAt: io.string,
  merchantID: io.string,
  programID: io.string,
  status: io.union([
    io.literal('ACTIVE'),
    io.literal('EXPIRED'),
    io.literal('DELETED'),
    io.literal('COMPLETED'),
    io.literal('VISITED'),
    io.literal('NOTIFIED'),
  ]),
  orderReference: io.string,
  contact: Contact,
  order: Order,
  disclosures: Disclosures,
  isHipaaRestricted: io.boolean,
});

export type Cart = io.TypeOf<typeof Cart>;
